// extracted by mini-css-extract-plugin
export default {"container":"chat_container__h071t","contentDiv":"chat_contentDiv__lDD4z"};